import { useQuery } from '@tanstack/react-query';
import http from '../../../utils/http';

export function useGetSingleProviderAppointments({ providerId = '' }: { providerId: string }) {
  const { data, ...rest } = useQuery({
    queryKey: ['single provider appointments', providerId || null],
    queryFn: async () => {
      const response = await http.get(`appointments/provider?providerId=${providerId}`);
      return response.data?.providersAvailability ?? {};
    },
    enabled: !!providerId, // prevents auto-fetching
  });

  return {
    singleProvider: data ?? {},
    ...rest,
  };
}
